import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import {
  UPDATE_USER_CONFIG,
  UPDATE_USER_CONFIG_LOADING,
} from 'TypeDefs/AppContext'
import { useMutation, useQuery } from '@apollo/client'
import GET_USER_CONFIG_QUERY from 'Apollo/Queries/GetUserConfig'
import { User } from 'TypeDefs/FunderOrgConfig'
import UPDATE_USER_SETTINGS from 'Apollo/Mutations/UpdateUserSettings'

const useUserConfig = () => {
  const { user } = useAuth0()
  const { nonprofitOrgConfig, userConfig } = useAppState()
  const email = user?.email
  const dispatch = useAppDispatch()
  const [updateUserSettings] = useMutation(UPDATE_USER_SETTINGS, {
    refetchQueries: [{ query: GET_USER_CONFIG_QUERY }],
    onError: () => {
      // even if this fails, we don't want to trap the user on the onboarding
      dispatch({
        type: UPDATE_USER_CONFIG,
        userConfig: {
          ...userConfig,
          lastLoggedInAt: new Date().toISOString(),
        },
      })
    },
  })

  const { data, loading } = useQuery<User>(GET_USER_CONFIG_QUERY, {
    skip: !email,
    context: { clientName: 'batched' },
  })
  useEffect(() => {
    if (data && !loading && data.user.id) {
      dispatch({
        type: UPDATE_USER_CONFIG,
        userConfig: data.user,
      })

      // if setLastLoggedIn has been set to true by Auth0ProviderWithHistory,
      // we update the lastLoggedInAt field in the user settings and prevent it from being called again
      if (window.setLastLoggedIn && nonprofitOrgConfig.orgId !== 0) {
        window.setLastLoggedIn = false
        updateUserSettings({
          variables: {
            userSettingsInfo: {
              firstName: data.user.firstName,
              lastName: data.user.lastName,
              lastLoggedInAt: new Date().toISOString(),
            },
            nonprofitOrgId: nonprofitOrgConfig.orgId,
          },
        })
      }
    }
  }, [data, loading, dispatch, updateUserSettings, nonprofitOrgConfig])

  useEffect(() => {
    dispatch({
      type: UPDATE_USER_CONFIG_LOADING,
      loading,
    })
  }, [loading, dispatch])
}
export default useUserConfig
